import { create } from 'zustand';

interface IStore {
  selectedDate?: Date;
  setSelectedDate: (prop: Date) => void;
}

export const useDateTime = create<IStore>(set => ({
  setSelectedDate: value => set(() => ({ selectedDate: value }))
}));
